var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCostEffective({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04397 3.146C6.82097 2.9405 7.66397 2.942 8.47797 2.9245C13.342 2.819 18.365 1.798 22.9715 3.364C24.0665 3.736 25.1455 4.275 25.8885 5.161C27.8375 7.4855 25.9 10.388 23.665 11.591C22.3785 12.2835 20.942 12.6345 19.5335 13.022C15.4725 14.14 11.4475 15.629 7.23847 15.792C5.94947 15.842 4.55797 15.73 3.55797 14.915C2.61497 14.146 2.20647 12.892 2.06647 11.683C1.81247 9.4935 2.30297 7.2245 3.43847 5.335C3.89047 4.5835 4.46297 3.8725 5.23647 3.4585C5.49347 3.321 5.76447 3.22 6.04397 3.146Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4601 8.38651C15.6146 8.38651 16.5501 9.3225 16.5501 10.4765C16.5501 11.631 15.6141 12.5665 14.4601 12.5665C13.3061 12.5665 12.3701 11.6305 12.3701 10.4765C12.3701 9.3225 13.3056 8.38651 14.4601 8.38651Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6367 29.37C18.6692 29.37 15.4672 27.82 15.3252 25.8365V15.8325C15.4712 13.8485 18.6732 12.2985 22.6367 12.2985C26.6052 12.2985 29.8057 13.8485 29.9432 15.831V25.68C29.9462 26.0325 29.7022 26.47 29.2562 26.9195C28.0492 28.1375 25.3877 29.37 22.6367 29.37Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3252 16.91L16.8247 17.9235C18.5787 19.0185 20.5962 19.6185 22.6227 19.6595C24.6767 19.6185 26.6897 19.0145 28.4437 17.919L29.9432 17.0285",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3252 21.945C16.7747 23.3175 19.7647 24.435 22.6412 24.435C25.3812 24.435 28.6712 23.022 29.9432 21.354",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.944 18.705C28.944 18.705 28.9395 18.705 28.9395 18.7095V18.687L28.944 18.705Z",
    fill: "#393B46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8878 17.4335C10.0023 17.361 8.11626 17.3015 6.23076 17.311C5.72626 17.3155 5.22676 17.32 4.72676 17.3565C4.56326 17.3655 4.40426 17.3885 4.24076 17.4065C4.02726 17.4245 4.04526 17.4975 3.93626 17.284C3.72276 16.857 3.75426 16.1255 3.71376 15.6575C3.65926 14.9985 3.63676 14.335 3.62726 13.6765C3.58576 10.949 3.75876 8.21348 3.99026 5.50098C4.04026 4.88298 4.09926 4.21948 4.17226 3.58348C5.07176 3.20198 6.22626 2.52948 7.23026 2.60648C8.02976 2.66998 24.4428 3.58798 24.4428 3.58798C24.4428 3.58798 25.4423 8.58648 24.9608 12.485",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCostEffective);
export default __webpack_public_path__ + "static/media/icon-cost-effective.84f3929e2598d9c881af3096e3149124.svg";
export { ForwardRef as ReactComponent };